(function () {
  'use strict';

  var MAX_SIZE_BYTES = 30 * 1024 * 1024;
  var ALLOWED_TYPES = ['video/mp4', 'video/quicktime'];
  var SIMULATED_DURATION_MS = 2500;

  function formatSize(bytes) {
    var mb = bytes / (1024 * 1024);
    return mb >= 10 ? Math.round(mb) + ' MB' : mb.toFixed(1) + ' MB';
  }

  function formatDuration(seconds) {
    if (!seconds || !isFinite(seconds)) return '';
    return Math.round(seconds) + ' seconds';
  }

  function initForm(section) {
    var form = section.querySelector('[data-review-form]');
    if (!form) return;

    var emailInput = form.querySelector('[data-email-input]');
    var fileInput = form.querySelector('[data-file-input]');
    var dropzone = form.querySelector('[data-dropzone]');
    var videoField = form.querySelector('[data-field="video"]');
    var fileError = form.querySelector('[data-file-error]');
    var dropzoneFile = form.querySelector('[data-dropzone-file]');
    var dropzoneRemove = form.querySelector('[data-dropzone-remove]');
    var checkboxes = Array.prototype.slice.call(form.querySelectorAll('[data-checkbox]'));
    var checkboxRows = Array.prototype.slice.call(form.querySelectorAll('[data-checkbox-row]'));
    var submitButton = form.querySelector('[data-submit-button]');
    var helperText = form.querySelector('[data-helper-text]');
    var submitError = form.querySelector('[data-submit-error]');

    var formView = section.querySelector('[data-form-view]');
    var successView = section.querySelector('[data-success-view]');

    var modal = section.querySelector('[data-upload-modal]');
    var uploadName = section.querySelector('[data-upload-name]');
    var uploadMeta = section.querySelector('[data-upload-meta]');
    var uploadBar = section.querySelector('[data-upload-bar]');
    var uploadPercent = section.querySelector('[data-upload-percent]');
    var cancelButton = section.querySelector('[data-upload-cancel]');

    var endpoint = section.getAttribute('data-upload-endpoint') || '';
    var selectedFile = null;
    var isUploading = false;
    var uploadTimer = null;
    var xhr = null;

    var backdrop = section.querySelector('[data-form-backdrop]');
    var closeButtons = section.querySelectorAll('[data-form-close]');

    function closeFormModal() {
      section.hidden = true;
      if (modal.hidden) document.documentElement.style.overflow = '';
      if (!isUploading) resetForm();
    }

    function resetForm() {
      selectedFile = null;
      fileInput.value = '';
      emailInput.value = '';
      emailInput.classList.remove('is-error');
      checkboxes.forEach(function (checkbox) {
        checkbox.checked = false;
      });
      if (dropzoneFile) {
        dropzoneFile.hidden = true;
        dropzoneFile.textContent = '';
      }
      dropzone.classList.remove('has-file');
      if (dropzoneRemove) dropzoneRemove.hidden = true;
      clearFileError();
      clearCheckboxErrors();
      if (submitError) submitError.hidden = true;
      formView.hidden = false;
      successView.hidden = true;
      updateState();
    }

    if (backdrop) {
      backdrop.addEventListener('click', closeFormModal);
    }
    closeButtons.forEach(function (button) {
      button.addEventListener('click', closeFormModal);
    });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !section.hidden) closeFormModal();
    });

    // Open the shared terms popup (rendered by the LH Reviews Legal section)
    form.querySelectorAll('[data-terms-open]').forEach(function (link) {
      link.addEventListener('click', function () {
        document.dispatchEvent(new CustomEvent('lh-terms:open'));
      });
    });

    function isEmailValid() {
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(emailInput.value.trim());
    }

    function isFileValid(file) {
      return ALLOWED_TYPES.indexOf(file.type) !== -1 && file.size <= MAX_SIZE_BYTES;
    }

    function isFormValid() {
      return isEmailValid() && selectedFile !== null && isFileValid(selectedFile);
    }

    function updateState() {
      var valid = isFormValid();
      submitButton.disabled = !valid;
      if (helperText) helperText.hidden = valid;
    }

    function showFileError() {
      videoField.classList.add('is-error');
      if (fileError) fileError.hidden = false;
    }

    function clearFileError() {
      videoField.classList.remove('is-error');
      if (fileError) fileError.hidden = true;
    }

    function clearCheckboxErrors() {
      checkboxRows.forEach(function (row) {
        row.classList.remove('is-error');
      });
    }

    function formatFileSize(bytes) {
      if (bytes < 1024) return bytes + ' B';
      if (bytes < 1024 * 1024) return Math.round(bytes / 1024) + ' KB';
      return (bytes / (1024 * 1024)).toFixed(1) + ' MB';
    }

    function handleFile(file) {
      if (!file) return;
      selectedFile = file;
      if (isFileValid(file)) {
        clearFileError();
        if (dropzoneFile) {
          dropzoneFile.textContent = file.name + '  ·  ' + formatFileSize(file.size);
          dropzoneFile.hidden = false;
          dropzone.classList.add('has-file');
        }
        if (dropzoneRemove) dropzoneRemove.hidden = false;
      } else {
        showFileError();
        if (dropzoneFile) {
          dropzoneFile.hidden = true;
          dropzone.classList.remove('has-file');
        }
        if (dropzoneRemove) dropzoneRemove.hidden = true;
      }
      updateState();
    }

    function clearSelectedFile() {
      selectedFile = null;
      fileInput.value = '';
      if (dropzoneFile) {
        dropzoneFile.hidden = true;
        dropzoneFile.textContent = '';
      }
      dropzone.classList.remove('has-file');
      if (dropzoneRemove) dropzoneRemove.hidden = true;
      clearFileError();
      updateState();
    }

    function readDuration(file, callback) {
      try {
        var url = URL.createObjectURL(file);
        var probe = document.createElement('video');
        probe.preload = 'metadata';
        probe.muted = true;
        probe.onloadedmetadata = function () {
          URL.revokeObjectURL(url);
          callback(probe.duration);
        };
        probe.onerror = function () {
          URL.revokeObjectURL(url);
          callback(null);
        };
        probe.src = url;
      } catch (error) {
        callback(null);
      }
    }

    function setProgress(percent) {
      var value = Math.min(100, Math.max(0, Math.round(percent)));
      uploadBar.style.width = value + '%';
      uploadPercent.textContent = value + '%';
    }

    function openModal(file) {
      uploadName.textContent = file.name;
      uploadMeta.textContent = formatSize(file.size);
      setProgress(0);
      modal.hidden = false;
      document.documentElement.style.overflow = 'hidden';

      readDuration(file, function (duration) {
        var durationLabel = formatDuration(duration);
        uploadMeta.textContent = durationLabel
          ? formatSize(file.size) + '  ·  ' + durationLabel
          : formatSize(file.size);
      });
    }

    function closeModal() {
      modal.hidden = true;
      document.documentElement.style.overflow = '';
    }

    function stopUpload() {
      if (uploadTimer) {
        clearInterval(uploadTimer);
        uploadTimer = null;
      }
      if (xhr) {
        xhr.abort();
        xhr = null;
      }
      isUploading = false;
      closeModal();
    }

    function showSuccess() {
      closeModal();
      isUploading = false;
      formView.hidden = true;
      successView.hidden = false;
      successView.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }

    function showSubmitError() {
      if (submitError) submitError.hidden = false;
      closeModal();
      isUploading = false;
    }

    function startSimulatedUpload() {
      var start = Date.now();
      uploadTimer = setInterval(function () {
        var elapsed = Date.now() - start;
        var progress = Math.min(100, (elapsed / SIMULATED_DURATION_MS) * 100);
        setProgress(progress);
        if (progress >= 100) {
          clearInterval(uploadTimer);
          uploadTimer = null;
          showSuccess();
        }
      }, 80);
    }

    function startRealUpload() {
      var formData = new FormData();
      formData.append('email', emailInput.value.trim());
      formData.append('video', selectedFile);

      xhr = new XMLHttpRequest();
      xhr.open('POST', endpoint);
      xhr.upload.onprogress = function (event) {
        if (event.lengthComputable) {
          setProgress((event.loaded / event.total) * 100);
        }
      };
      xhr.onload = function () {
        xhr = null;
        if (this.status >= 200 && this.status < 300) {
          setProgress(100);
          showSuccess();
        } else {
          showSubmitError();
        }
      };
      xhr.onerror = function () {
        xhr = null;
        showSubmitError();
      };
      xhr.onabort = function () {
        xhr = null;
      };
      xhr.send(formData);
    }

    function startUpload() {
      isUploading = true;
      if (submitError) submitError.hidden = true;
      openModal(selectedFile);
      if (endpoint) {
        startRealUpload();
      } else {
        startSimulatedUpload();
      }
    }

    emailInput.addEventListener('input', function () {
      emailInput.classList.toggle('is-error', emailInput.value.trim() !== '' && !isEmailValid());
      updateState();
    });

    fileInput.addEventListener('change', function () {
      handleFile(fileInput.files[0]);
    });

    dropzone.addEventListener('click', function () {
      fileInput.click();
    });

    if (dropzoneRemove) {
      dropzoneRemove.addEventListener('click', function (event) {
        event.preventDefault();
        clearSelectedFile();
      });
    }

    ['dragenter', 'dragover'].forEach(function (eventName) {
      dropzone.addEventListener(eventName, function (event) {
        event.preventDefault();
        dropzone.classList.add('is-dragover');
      });
    });

    ['dragleave', 'drop'].forEach(function (eventName) {
      dropzone.addEventListener(eventName, function (event) {
        event.preventDefault();
        dropzone.classList.remove('is-dragover');
      });
    });

    dropzone.addEventListener('drop', function (event) {
      var file = event.dataTransfer && event.dataTransfer.files && event.dataTransfer.files[0];
      if (file) {
        fileInput.files = event.dataTransfer.files;
        handleFile(file);
      }
    });

    checkboxes.forEach(function (checkbox) {
      checkbox.addEventListener('change', function () {
        checkboxRows.forEach(function (row) {
          var input = row.querySelector('[data-checkbox]');
          if (input && input.checked) row.classList.remove('is-error');
        });
      });
    });

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      if (isUploading || !isFormValid()) return;

      clearCheckboxErrors();
      var allChecked = checkboxes.every(function (checkbox) {
        return checkbox.checked;
      });

      if (!allChecked) {
        checkboxRows.forEach(function (row) {
          var input = row.querySelector('[data-checkbox]');
          if (input && !input.checked) row.classList.add('is-error');
        });
        return;
      }

      startUpload();
    });

    cancelButton.addEventListener('click', function () {
      stopUpload();
    });

    updateState();
  }

  document.addEventListener('lh-reviews-form:open', function () {
    var section = document.querySelector('.lh-reviews-form');
    if (!section || !section.hidden) return;
    section.hidden = false;
    document.documentElement.style.overflow = 'hidden';
  });

  document.querySelectorAll('.lh-reviews-form').forEach(initForm);
})();
